import React, { useState } from 'react';
import { Typography, Popover, Link } from '@mui/material';
import PropTypes from 'prop-types';

const TruncatedTextDisplay = (props) => {
    const { text, maxLength, popOverMaxWidth, anchorOrigin, transformOrigin } =
        props;
    const [anchorEl, setAnchorEl] = useState(null);

    const isLong = text.length > maxLength;
    const displayText = isLong ? `${text.substring(0, maxLength)}... ` : text;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Typography
                variant="body2"
                sx={{
                    // overflow: 'hidden',
                    // textOverflow: 'ellipsis',
                    textAlign: 'left',
                }}
            >
                {displayText}
                {isLong && (
                    <Link
                        component="button"
                        onClick={handleClick}
                        underline="none"
                    >
                        more
                    </Link>
                )}
            </Typography>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                PaperProps={{
                    sx: { maxWidth: popOverMaxWidth, p: 1 }, // Set padding here if needed
                }}
            >
                <Typography
                    component={'pre'}
                    sx={{
                        p: 2,
                        whiteSpace: 'pre-wrap', // or 'pre' to preserve exact formatting
                        //overflowX: 'auto',
                    }}
                >
                    {text}
                </Typography>
            </Popover>
        </>
    );
};

TruncatedTextDisplay.propTypes = {
    text: PropTypes.string,
    maxLength: PropTypes.number,
    popOverMaxWidth: PropTypes.string,
    anchorOrigin: PropTypes.shape({}),
    transformOrigin: PropTypes.shape({}),
};

TruncatedTextDisplay.defaultProps = {
    maxLength: 100,
    popOverMaxWidth: 300,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
    },
};

export default TruncatedTextDisplay;
